export default "__VITE_ASSET__BxY43sOK__"